import { render, staticRenderFns } from "./favorite-list.vue?vue&type=template&id=40852938&scoped=true"
import script from "./favorite-list.vue?vue&type=script&lang=js"
export * from "./favorite-list.vue?vue&type=script&lang=js"
import style0 from "./favorite-list.vue?vue&type=style&index=0&id=40852938&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/user/myFavourite.less?vue&type=style&index=1&id=40852938&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40852938",
  null
  
)

export default component.exports